<template>
  <div class="hello">

    <el-form ref="form" :model="form" :rules="rules" label-width="80px">
      <el-form-item label="Name" prop="name">
        <el-input v-model="form.name" maxlength="10" show-word-limit :disabled="true"></el-input>
      </el-form-item>
      <el-form-item label="Medicine" prop="medicine">
        <el-input v-model="form.medicine" maxlength="10" show-word-limit :disabled="true"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onSubmit('form')">Submit</el-button>
      </el-form-item>
    </el-form>

  </div>
</template>

<script>
export default {
  name: 'Review',
  data() {
      return {
        ReviewApi: 'http://www,google.com',
        form: {
          name: '',
          medicine: '',
        }, 
        rules: {
          name: [
            { required: true, message: '请输入患者姓名', trigger: 'blur' },
            { min: 2, max: 10, message: '长度在 2 到 10 个字符', trigger: 'blur' }
          ],
          medicine: [
            { required: true, message: '请选择药品名字', trigger: 'change' }
          ],
        }
      }
    },
  props: {
    msg: String,
  },
  methods: {
    onSubmit() {
      this.$confirm('是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
            this.axios
            .get(this.DoctorApprovalApi)
            .then(response => (this.info = response.data))
            .catch(function(err) {
                alert(err);
            });
        }).catch(() => {
          //this.$message({
          //  type: 'info',  // success
          //  message: '已取消删除'
          // });          
        });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    }
  },
  mounted () {
    var __this = this;
    this.axios.get(__this.getMedicineListApi).then(function(res) {
        var data = res.data;
        console.log(data)
        for(var item of data){
          __this.medicineOptions.add({
            label: item.value,
            value: item.value
          });
        }
    }).catch(function(err) {
        console.log(err)
    });
  }
}
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}

</style>
